import React from 'react';

const AcademicPage_3_CHI_LBW = () => {
  return (
    <div style={{ backgroundColor: 'white', minHeight: '100vh', fontFamily: 'Georgia, serif' }}>
      
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
        
        {/* 标题 */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h1 style={{ 
            fontSize: '36px', 
            fontWeight: 'normal', 
            color: '#333', 
            lineHeight: '1.2',
            marginBottom: '20px'
          }}>
            Exploring and Modeling Gaze-Based Steering Behavior in Virtual Reality
          </h1>
          
          {/* 作者列表 */}
          <div style={{ fontSize: '16px', color: '#666', lineHeight: '1.5' }}>
            Xuning Hu, <span style={{ color: '#4A90E2', fontWeight: 'bold' }}>Yichuan Zhang</span>, Yushi Wei, Yue Li, Wolfgang Stuerzlinger, Hai-Ning Liang
          </div>
        </div>

        {/* 摘要部分 */}
        <div style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: 'normal', 
            color: '#333', 
            textAlign: 'center',
            marginBottom: '30px',
            fontStyle: 'italic'
          }}>
            Abstract
          </h2>
          
          <div style={{ 
            fontSize: '16px', 
            color: '#444', 
            lineHeight: '1.6', 
            textAlign: 'justify'
          }}>
            <p style={{ marginBottom: '20px' }}>
            Virtual reality (VR) environments present unique challenges for user interaction, particularly in steering tasks 
            where users must navigate through constrained pathways. Gaze-based steering offers a promising alternative to 
            traditional input methods, leveraging the natural and intuitive nature of eye movements. This late-breaking work 
            presents preliminary findings from our investigation into gaze-based steering behavior in VR, focusing on the 
            relationship between steering performance and various environmental factors. We conducted an exploratory study 
            with 16 participants to examine how different path configurations, visual feedback mechanisms, and user experience 
            levels affect steering accuracy and efficiency. Our initial results suggest that gaze-based steering performance 
            is significantly influenced by path complexity and the presence of visual guidance cues. We also observe distinct 
            behavioral patterns that differ from traditional mouse-based steering, particularly in terms of movement precision 
            and adaptation strategies. These early findings contribute to the growing body of knowledge on gaze-based interaction 
            in VR and provide a foundation for future research on optimizing steering interfaces for immersive environments.
            </p>
          
          </div>
        </div>

        {/* 按钮部分 */}
        <div style={{ marginBottom: '40px' }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: '20px',
            flexWrap: 'wrap'
          }}>
                         <button style={{
               padding: '10px 20px',
               fontSize: '14px',
               fontWeight: 'normal',
               color: '#000',
               backgroundColor: '#fff',
               border: '1px solid #000',
               borderRadius: '4px',
               cursor: 'pointer',
               transition: 'all 0.2s ease',
               minWidth: '100px',
               fontFamily: 'Arial, sans-serif'
             }}
             onMouseOver={(e) => {
               e.target.style.backgroundColor = '#f5f5f5';
             }}
             onMouseOut={(e) => {
               e.target.style.backgroundColor = '#fff';
             }}>
               Code
             </button>
             
             <button style={{
               padding: '10px 20px',
               fontSize: '14px',
               fontWeight: 'normal',
               color: '#000',
               backgroundColor: '#fff',
               border: '1px solid #000',
               borderRadius: '4px',
               borderRadius: '4px',
               cursor: 'pointer',
               transition: 'all 0.2s ease',
               minWidth: '100px',
               fontFamily: 'Arial, sans-serif'
             }}
             onMouseOver={(e) => {
               e.target.style.backgroundColor = '#f5f5f5';
             }}
             onMouseOut={(e) => {
               e.target.style.backgroundColor = '#fff';
             }}>
               Website
             </button>
             
             <button style={{
               padding: '10px 20px',
               fontSize: '14px',
               fontWeight: 'normal',
               color: '#000',
               backgroundColor: '#fff',
               border: '1px solid #000',
               borderRadius: '4px',
               cursor: 'pointer',
               transition: 'all 0.2s ease',
               minWidth: '100px',
               fontFamily: 'Arial, sans-serif'
             }}
             onMouseOver={(e) => {
               e.target.style.backgroundColor = '#f5f5f5';
             }}
             onMouseOut={(e) => {
               e.target.style.backgroundColor = '#fff';
             }}>
               Paper
             </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AcademicPage_3_CHI_LBW;
